import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { TreeMap } from '../../../Common/Charts/TreeMap';
import { useGeneralProductionChartsDataContext } from './hooks/useGeneralProductionChartsDataContext';

export const ServiceByType = () => {
    const { chartData } = useGeneralProductionChartsDataContext();

    return (
        <TreeMap
            title={'Atendimento por tipo de atendimento'}
            subtitles={chartData?.servicesByType?.map((item) => item.description)}
            values={chartData?.servicesByType?.map((item) => item.total)}
            colors={defaultColors.slice(0, chartData?.servicesByType?.length) || []}
            height={350}
        />
    );
};
